<template>
  <screen
    class="preview-wrapper"
    :screen-info="$t('mobileScan.preview_info')"
    :can-skip="false"
    :can-leave="false"
    center-titles
  >
    <div class="img-placeholder">
      <!-- video goes here -->
    </div>
    <check-item short v-for="(c, i) in checkList" :key="i" :item="c" @checked="onItemCheck(i)" />
    <template #footer>
      <c-button :confirmed-status="passed" @click="goUpload">
        <span>{{ $t('mobileScan.next') }}</span>
      </c-button>
      <c-button secondary class="mt-3" @click="rescan">
        <span>{{ $t('mobileScan.rescan') }}</span>
      </c-button>
    </template>
  </screen>
</template>

<script>
import ScanProcess from '@/modules/scan-process';
import { EVENTS as HW_EVENTS } from '@/events/hardware';
import audioPlayer from '@/mixins/audio-player';
import Screen from '@/components/common/Screen.vue';
import CButton from '@/components/common/CButton.vue';
import CheckItem from '@/components/MobileScan/Tutorial/CheckItem.vue';

export default {
  name: 'Preview',
  props: {
    video: String,
  },
  mixins: [audioPlayer],
  components: {
    Screen,
    CButton,
    CheckItem,
  },
  mounted() {
    this.showVideo();
    this.playAudio('ms-15-review', true);
  },
  data: vm => ({
    index: 0,
    checkList: [
      { info: vm.$t('mobileScan.preview_inscreen'), checked: false },
      { info: vm.$t('mobileScan.preview_arms_open'), checked: false },
      { info: vm.$t('mobileScan.preview_spin'), checked: false },
    ],
  }),
  methods: {
    onItemCheck(index) {
      const item = this.checkList[index];
      this.$set(item, 'checked', true);
      const nextIndex = this.checkList.findIndex(c => !c.checked);
      this.index = nextIndex > -1 ? nextIndex : index;
    },
    showVideo() {
      // TODO: actually set styles
      // this.$events.emit(HW_EVENTS.SET_OVERLAY_STYLES, {});
      this.$events.emit(HW_EVENTS.SHOW_VIDEO, this.video);
    },
    hideVideo() {
      this.$events.emit(HW_EVENTS.HIDE_VIDEO);
    },
    goUpload() {
      this.$events.emit(HW_EVENTS.START_MOBILE_SCAN_UPLOADING, ScanProcess.in3dId);
      this.hideVideo();
      this.$events.goto('MobileScan/Uploading');
    },
    rescan() {
      this.$events.emit(HW_EVENTS.CLOSE_MOBILE_SCAN);
      this.hideVideo();
      this.$events.goto('MobileScan/Scan');
    },
  },
  computed: {
    currentCheck() {
      return this.checkList[this.index];
    },
    passed() {
      return this.checkList.every(c => c.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-wrapper {
  ::v-deep .screen-titles {
    @apply mt-10 mb-6;
  }
}
.img-placeholder {
  @apply -mt-16 mb-5;
  min-height: 336px;
}
</style>
